import React from 'react';
import DictionaryFieldCardItem from '../containers/DictionaryFieldCardItem';

const DictionaryFieldCardItems = ({
  canEdit,
  category,
  code,
  dictionaryUUID,
  fields,
  isEditing,
  lookups,
  template,
}) => (
  Object.keys(fields).map((key, index) => (
    <DictionaryFieldCardItem
      key={`dictionary_list_item_${code}_${fields[key].uuid}`}
      canEdit={canEdit}
      category={category}
      code={code}
      dictionaryUUID={dictionaryUUID}
      field={fields[key]}
      isEditing={isEditing}
      lookups={lookups}
      template={template}
      upward={index > 4}
    />
  ))
);

export default DictionaryFieldCardItems;
